import { Component, EventEmitter, Input, Output, ContentChild, AfterViewInit } from '@angular/core';
import { listActionStyles, ListProps, listSideStyles, listStyles } from '@kite_aerolab/shared/components';
import { AvatarComponent } from '../avatar/avatar.component';

@Component({
  selector: 'kite-list',
  template: `
    <div [ngClass]="listStyles" (click)="onClick.emit($event)">
      <ng-content select="kite-avatar"></ng-content>
      <ng-content select="kite-list-content"></ng-content>
      <ng-content select="kite-list-side"></ng-content>
      <ng-content select="kite-list-actions"></ng-content>
    </div>
  `,
})
export class ListComponent implements AfterViewInit {
  @ContentChild(AvatarComponent, { static: false }) avatar: AvatarComponent;
  /**
   * Tamaño del list: sm o extra small
   */
  @Input() size: ListProps['size'];
  /**
   * Tamaño del list: sm o extra small
   */
   @Input() isDisabled: ListProps['isDisabled'];
  /**
   * CSS del componente
   */
  @Input() css: ListProps['css'];

  @Output() onClick: EventEmitter<Event> = new EventEmitter();

  public get listStyles(): string[] {
    return [
      listStyles({
        size: this.size,
        isDisabled: this.isDisabled,
        css: this.css,
      }).className,
    ];
  }

  public get listSideStyles(): string[] {
    return [listSideStyles().className];
  }

  public get listActionStyles(): string[] {
    return [listActionStyles().className];
  }

  ngAfterViewInit () {
    if (this.avatar) {    
      this.avatar.size = 'sm',
      this.avatar.shape = 'circle'
    }
  }
}
